import { css, cx } from "react-emotion";
import { observer } from "mobx-react";
import Button from "components/Button";
import Cookies from "js-cookie";
import React, { Component } from "react";
import theme from "components/theme";

class CookieConsentBox extends Component {
  state = { agreed: false };

  agree = () => {
    this.setState({ agreed: true });
  };

  componentDidMount = () => {
    Cookies.set(`cookieAgreed`, "true", { expires: 365 * 5 });
  };

  render() {
    const { styles } = this;

    if (this.state.agreed || Cookies.get("cookieAgreed")) return null;

    return (
      <div className={styles.root}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-9 col-md-10">
              Um unsere Webseite für dich optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir
              Cookies. Durch die weitere Nutzung der Webseite stimmst du der Verwendung von Cookies zu. Weitere
              Informationen zu Cookies erhältst du in unserer{" "}
              <a href="/datenschutz/" target="_blank">
                Datenschutzerklärung
              </a>{" "}
            </div>
            <div className="col-xs-12 col-sm-3 col-md-2 buttonCol">
              <Button onClick={this.agree} className={cx(["s"])}>
                Alles Klar
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  styles = {
    root: css`
      ${"" /* font-size: 12px; */};
      width: 100%;
      position: fixed;
      bottom: 0px;
      padding: 20px 0px;
      ${"" /* opacity: 0.75; */};
      background-color: #bababa;
      color: #fff;
      font-size: 12px;
      z-index: 11;
      text-align: justify;

      a,
      a:hover {
        color: #fff !important;
      }

      ${theme.media.xsMax} {
        padding: 5px 0px;
        font-size: 12px;
      }
      .buttonCol {
        text-align: right;
        button {
          font-size: 14px;
          padding: 0px 20px;
        }

        ${theme.media.xsMax} {
          margin-top: 5px;
          text-align: center;

          button {
            font-size: 14px;
          }
        }
      }
    `,
  };
}

CookieConsentBox = observer(CookieConsentBox);

export default CookieConsentBox;
